import React from 'react'

const UserAuthContext = React.createContext()

export default UserAuthContext
